/* BB Segundo par: add-on opcional del buy box de lectura (snippets/bb-segundo-par.liquid). */
(function () {
  'use strict';
  if (window.__bbSegundoPar) return;
  window.__bbSegundoPar = true;

  function init() {
    var root = document.querySelector('[data-bb-sp]');
    if (!root) return;

    var d = root.dataset;
    var section = document.getElementById('shopify-section-' + d.sectionId) || document;
    var form = section.querySelector('form[action*="/cart/add"]');
    var button = form && form.querySelector('[data-add-to-cart]');
    var buttonText = button && button.querySelector('[data-add-to-cart-text]');
    var cohort = window.bbSpCohorte === 'a' ? 'a' : 'b';
    /* En un theme sin publicar (vista previa) se ve el módulo, pero no se mide nada. */
    var experiment = d.modo === 'ab' && !window.bbSpPreview;
    var active = d.modo === 'todos' || (d.modo === 'ab' && cohort === 'b');
    var mainPct = parseInt(d.pct, 10) || 0;
    var max = parseInt(d.max, 10) || 6;
    var otherEnabled = d.otroAumento === 'true';
    var mainVariants = (d.mainVariants || '').split(',');
    var defaultLabel = buttonText ? (buttonText.getAttribute('data-default-text') || buttonText.textContent).trim() : '';
    var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var el = {
      grid: root.querySelector('[data-bb-sp-grid]'),
      body: root.querySelector('[data-bb-sp-body]'),
      sub: root.querySelector('[data-bb-sp-sub]'),
      summary: root.querySelector('[data-bb-sp-summary]'),
      clear: root.querySelector('[data-bb-sp-clear]'),
      note: root.querySelector('[data-bb-sp-note]'),
      msg: root.querySelector('[data-bb-sp-msg]'),
      other: root.querySelector('[data-bb-sp-other]'),
      otherToggle: root.querySelector('[data-bb-sp-other-toggle]'),
      otherOptions: root.querySelector('[data-bb-sp-other-options]')
    };

    var tiles = Array.prototype.map.call(root.querySelectorAll('[data-bb-sp-tile]'), function (node) {
      var variants = {};
      try { variants = JSON.parse(node.getAttribute('data-variants') || '{}'); } catch (e) {}
      return {
        node: node,
        input: node.querySelector('input'),
        price: node.querySelector('[data-bb-sp-price]'),
        handle: node.getAttribute('data-handle'),
        title: node.getAttribute('data-title'),
        pct: parseInt(node.getAttribute('data-pct'), 10) || 0,
        companion: node.getAttribute('data-companion') === 'true',
        src: node.getAttribute('data-src') || (node.getAttribute('data-companion') === 'true' ? 'companero' : 'hermano'),
        variants: variants,
        wasSelected: false
      };
    });

    var state = {
      value: d.value,
      mainPrice: parseInt(d.price, 10) || 0,
      mainAvailable: d.available !== 'false',
      selected: null,
      secondValue: null,
      chipsFor: null,
      stale: null,
      busy: false
    };

    function fill(text, values) {
      return String(text || '').replace(/\{(\w+)\}/g, function (match, key) {
        return values[key] != null ? values[key] : match;
      });
    }

    function money(cents) {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
      return '$' + Math.round(cents / 100).toLocaleString('es-CL');
    }

    function track(name, params) {
      var privacy = window.Shopify && Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;
      params = params || {};
      try {
        if (typeof window.gtag === 'function') window.gtag('event', name, params);
        else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params));
      } catch (e) {}
    }

    /* El 2.º par usa el aumento de la ficha, salvo que para el tile elegido se haya pedido otro. */
    function valueFor(tile) {
      return tile === state.selected && state.secondValue && tile.variants[state.secondValue] ? state.secondValue : state.value;
    }

    function offer(tile) {
      return tile.variants[valueFor(tile)] || null;
    }

    function visibleTiles() {
      return tiles.filter(function (t) { return !t.node.hidden && !t.node.classList.contains('is-unavailable'); });
    }

    function position(tile) {
      return visibleTiles().indexOf(tile) + 1;
    }

    /* Shopify descuenta el par más barato; el carrito es la fuente de verdad. */
    function pricing(tile) {
      var second = offer(tile)[1];
      var pct = Math.min(mainPct, tile.pct);
      var saving = pct ? Math.round(Math.min(state.mainPrice, second) * pct / 10000) * 100 : 0;
      return { second: second, pct: pct, saving: saving, total: state.mainPrice + second - saving };
    }

    function hiddenText(text) {
      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = text + ' ';
      return span;
    }

    /* Con descuento: precio normal tachado y precio del 2.º par con el % ya aplicado. */
    function setPrice(tile, p) {
      var node = tile.price;
      node.textContent = p.saving ? '' : money(p.second);
      if (!p.saving) return;
      var was = document.createElement('s');
      was.className = 'bb-sp__was';
      was.appendChild(hiddenText(d.tWas));
      was.appendChild(document.createTextNode(money(p.second)));
      var now = document.createElement('span');
      now.className = 'bb-sp__now';
      now.appendChild(hiddenText(d.tNow));
      now.appendChild(document.createTextNode(money(p.second - p.saving)));
      node.appendChild(was);
      node.appendChild(document.createTextNode(' '));
      node.appendChild(now);
    }

    function render() {
      var shown = 0;
      tiles.forEach(function (tile) {
        var available = offer(tile);
        var stale = state.stale === tile;
        var visible = stale || (!!available && shown < max);
        if (visible && !stale) shown += 1;
        tile.node.hidden = !visible;
        tile.node.classList.toggle('is-unavailable', stale);
        tile.input.disabled = stale;
        if (available) setPrice(tile, pricing(tile));
        else if (stale) tile.price.textContent = fill(d.tUnavailable, { aumento: state.value });
      });
      el.grid.setAttribute('data-count', shown + (state.stale ? 1 : 0));
      var empty = !state.mainAvailable || (shown === 0 && !state.stale);
      root.toggleAttribute('data-empty', empty);
      el.sub.textContent = fill(d.tSub, { aumento: state.value });
    }

    /* El botón nunca cambia de alto: si el texto largo no cabe en una línea, usa el corto. */
    function setButton(total) {
      if (!active || !buttonText || button.disabled) return;
      buttonText.textContent = defaultLabel;
      if (total == null) return;
      var singleLine = button.offsetHeight;
      buttonText.textContent = fill(d.tButton, { total: money(total) });
      if (button.offsetHeight > singleLine + 1) buttonText.textContent = fill(d.tButtonShort, { total: money(total) });
    }

    function emit(count, total) {
      if (!active) return;
      document.dispatchEvent(new CustomEvent('bb:segundo-par:change', {
        detail: { count: count, total: total, totalText: money(total) }
      }));
    }

    function updateSelection() {
      var tile = state.selected && offer(state.selected) ? state.selected : null;
      state.selected = tile;
      tiles.forEach(function (t) {
        t.node.classList.toggle('is-selected', t === tile);
        t.input.checked = t === tile;
      });
      if (tile) {
        var p = pricing(tile);
        var other = valueFor(tile) !== state.value;
        var values = { color: tile.title, aumento: valueFor(tile), ahorro: money(p.saving), precio: money(p.second) };
        el.summary.textContent = p.pct
          ? fill(other ? d.tSummaryPctOther : d.tSummaryPct, values)
          : fill(other ? d.tSummaryOther : d.tSummary, values);
        el.summary.classList.add('is-active');
        el.clear.hidden = false;
        el.note.hidden = !p.pct;
        setButton(p.total);
        emit(2, p.total);
        updateOther(tile);
      } else {
        updateOther(null);
        el.summary.textContent = d.tHelp || '';
        el.summary.classList.remove('is-active');
        el.clear.hidden = true;
        el.note.hidden = true;
        setButton(null);
        emit(1, state.mainPrice);
      }
    }

    /* «¿Es para otra persona?»: chips con los aumentos con stock del tile elegido. Por defecto, el mismo de la ficha. */
    function buildChips(tile) {
      el.otherOptions.textContent = '';
      Object.keys(tile.variants).forEach(function (value) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bb-sp__chip';
        chip.setAttribute('data-value', value);
        chip.textContent = value === state.value ? fill(d.tOtherSame, { aumento: value }) : value;
        chip.addEventListener('click', function () {
          state.secondValue = value === state.value ? null : value;
          render();
          updateSelection();
          track('bb_sp_otro_aumento', { handle: tile.handle, aumento: state.value, aumento2: value, distinto: value === state.value ? 0 : 1 });
        });
        el.otherOptions.appendChild(chip);
      });
      state.chipsFor = tile;
    }

    function setOtherOpen(open) {
      if (!el.otherToggle) return;
      el.otherToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      el.otherOptions.hidden = !open;
    }

    function updateOther(tile) {
      if (!el.other) return;
      var show = otherEnabled && !!tile && Object.keys(tile.variants).length > 1;
      el.other.hidden = !show;
      if (!show) {
        setOtherOpen(false);
        state.chipsFor = null;
        return;
      }
      if (state.chipsFor !== tile) {
        setOtherOpen(state.secondValue != null);
        buildChips(tile);
      }
      Array.prototype.forEach.call(el.otherOptions.children, function (chip) {
        var value = chip.getAttribute('data-value');
        chip.setAttribute('aria-pressed', value === valueFor(tile) ? 'true' : 'false');
        chip.textContent = value === state.value ? fill(d.tOtherSame, { aumento: value }) : value;
      });
    }

    /* Carrusel móvil: trae a la vista el tile elegido sin mover la página en vertical. */
    function revealTile(tile) {
      var grid = el.grid.getBoundingClientRect();
      var box = tile.node.getBoundingClientRect();
      if (box.left >= grid.left && box.right <= grid.right) return;
      var left = el.grid.scrollLeft + (box.left < grid.left ? box.left - grid.left - 17 : box.right - grid.right + 17);
      if (el.grid.scrollTo) el.grid.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
      else el.grid.scrollLeft = left;
    }

    /* Sin estado «ya tienes tu 2.º par»: el descuento «25% OFF SEGUNDA UNIDAD» no tiene límite por
       orden (con 4 pares aplica a 2), así que el módulo sigue ofreciendo después de agregar. */

    var stamped = false;
    function onAdded(count, tile) {
      if (experiment) track('bb_sp_atc_' + cohort, { pares: count });
      if (count === 2 && tile) {
        track('bb_sp_add2', { color: tile.title, handle: tile.handle, src: tile.src, pos: tile.pos || 0, aumento: state.value,
          aumento2: tile.value2 || state.value, distinto: tile.value2 && tile.value2 !== state.value ? 1 : 0, companero: tile.companion ? 1 : 0 });
      }
      if (experiment && !stamped) {
        stamped = true;
        fetch(cartRoot + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { bb_sp_cohorte: cohort } })
        }).catch(function () { stamped = false; });
      }
      state.selected = null;
      state.secondValue = null;
      updateSelection();
    }

    var ownEvent = false;
    function announceAdded(json, count, tile) {
      ownEvent = true;
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: (json.items || [json])[0], addToCartBtn: button },
        bubbles: true
      }));
      ownEvent = false;
      onAdded(count, tile);
    }

    function mainItem() {
      var data = new FormData(form);
      var item = { id: parseInt(data.get('id'), 10), quantity: parseInt(data.get('quantity'), 10) || 1 };
      var properties = {};
      data.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(key);
        if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
      });
      if (Object.keys(properties).length) item.properties = properties;
      if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
      return item;
    }

    function post(items) {
      return fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.json().then(function (json) { return { ok: response.ok, json: json }; });
      });
    }

    var bypass = false;
    function submitNatively() {
      bypass = true;
      try {
        if (form.requestSubmit) form.requestSubmit(button);
        else button.click();
      } finally {
        bypass = false;
      }
    }

    function addPair(tile, variant) {
      state.busy = true;
      button.classList.add('btn--loading');
      var first = mainItem();
      var second = { id: variant[0], quantity: 1, properties: { _bb_rec: 'w:segundo-par', _bb_src: tile.src } };
      tile.pos = position(tile);
      tile.value2 = valueFor(tile);
      post([first, second])
        .then(function (res) {
          if (res.ok) return announceAdded(res.json, 2, tile);
          return post([first]).then(function (single) {
            if (!single.ok) return submitNatively();
            announceAdded(single.json, 1, null);
            el.msg.textContent = fill(d.tSold, { color: tile.title, producto: d.mainTitle });
          });
        })
        .catch(submitNatively)
        .then(function () {
          state.busy = false;
          button.classList.remove('btn--loading');
        });
    }

    tiles.forEach(function (tile) {
      tile.node.addEventListener('pointerdown', function () {
        tile.wasSelected = state.selected === tile;
      });
      tile.node.addEventListener('click', function (event) {
        if (tile.input.disabled || !tile.wasSelected || state.selected !== tile) return;
        event.preventDefault();
        tile.wasSelected = false;
        state.selected = null;
        state.secondValue = null;
        updateSelection();
      });
      tile.input.addEventListener('change', function () {
        if (!tile.input.checked) return;
        if (state.selected !== tile) state.secondValue = null;
        state.selected = tile;
        el.msg.textContent = '';
        updateSelection();
        revealTile(tile);
        track('bb_sp_select', { color: tile.title, handle: tile.handle, src: tile.src, pos: position(tile), aumento: state.value, companero: tile.companion ? 1 : 0 });
      });
    });

    if (el.otherToggle) {
      el.otherToggle.addEventListener('click', function () {
        var open = el.otherToggle.getAttribute('aria-expanded') !== 'true';
        setOtherOpen(open);
        if (open && state.selected) track('bb_sp_otro_aumento_abrir', { handle: state.selected.handle, aumento: state.value });
      });
    }

    el.clear.addEventListener('click', function () {
      var tile = state.selected;
      state.selected = null;
      state.secondValue = null;
      updateSelection();
      if (tile && !tile.node.hidden) tile.input.focus();
    });

    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || mainVariants.indexOf(String(variant.id)) === -1) return;
      state.value = variant.options[0];
      state.mainPrice = variant.price;
      state.mainAvailable = !!variant.available;
      state.stale = null;
      el.msg.textContent = '';
      if (state.secondValue === state.value) state.secondValue = null;
      state.chipsFor = null;
      if (state.selected && !offer(state.selected)) {
        state.stale = state.selected;
        state.selected = null;
      }
      render();
      updateSelection();
      if (!state.selected && !state.stale) el.grid.scrollLeft = 0;
    });

    if (form) {
      document.addEventListener('submit', function (event) {
        if (event.target !== form || bypass || !active || state.busy || !state.selected) return;
        var variant = offer(state.selected);
        if (!variant) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        addPair(state.selected, variant);
      }, true);

      form.addEventListener('ajaxProduct:added', function (event) {
        if (ownEvent || !event.detail || !event.detail.product) return;
        onAdded(1, null);
      });
    }

    render();
    updateSelection();
    if (experiment && !root.hasAttribute('data-empty')) track('bb_sp_view_' + cohort, {});

    /* Impresión real: el módulo entró en pantalla. Base del aprendizaje por clics (orden por ficha). */
    if (experiment && active && !root.hasAttribute('data-empty') && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        var box = el.grid.getBoundingClientRect();
        var shownTiles = visibleTiles();
        var params = { aumento: state.value, n: shownTiles.length, vis: shownTiles.filter(function (t) {
          var r = t.node.getBoundingClientRect();
          return r.left >= box.left - 1 && r.right <= box.right + 1;
        }).length };
        shownTiles.slice(0, 8).forEach(function (t, i) { params['t' + (i + 1)] = t.handle + '|' + t.src; });
        track('bb_sp_impresion', params);
      }, { threshold: 0.5 });
      observer.observe(el.grid);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
